import { Spinner } from '@fluentui/react';
import { makeAutoObservable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import API from '../../../API';
import { IUserConfigPackage } from '../../../API';

export interface IDocumentPreviewHTMLProps {
	state: DocumentPreviewHTMLState;
}

export class DocumentPreviewHTMLState {
	public fileName: string = '';
	public filePreviewHref: string = '';
	public loading: boolean = false;
	public isFullscreen: boolean = false;

	public headerMargin: number = 200;
	userConfig: IUserConfigPackage;

	constructor(userConfig:IUserConfigPackage) {
		this.userConfig = userConfig;
		makeAutoObservable(this);
	}

	//hack time. the 200px thing was put in because that was the size of the header, but sometimes the page isn't rendered with a header
	public setHeaderMargin(i: number) {
		this.headerMargin = i;
	}

	public setIsFullscreen(val: boolean) {
		this.isFullscreen = val;
	}

	public reset() {
		this.fileIdOrUrl = '';
		this.fileName = '';
		this.loading = false;
	}

	public setLoading(loading: boolean) {
		this.loading = loading;
	}

	public fileIdOrUrl: string = '';
	public async setFileIdOrUrl(idOrUrl: string): Promise<void> {
		if (this.fileIdOrUrl !== idOrUrl) {
			this.fileIdOrUrl = idOrUrl;
			this.load();
		}
	}

	public setFilePreviewHref(href: string): void {
		this.filePreviewHref = href;
	}

	private async load(): Promise<void> {
		if (this.fileIdOrUrl) {
			this.setLoading(true);
			
			var api = new API(await this.userConfig.getToken());
			this.setFilePreviewHref(await api.webPreviewUrl(this.fileIdOrUrl));
			this.setLoading(false);
		}
	}
}

class DocumentPreviewHTML extends React.PureComponent<IDocumentPreviewHTMLProps> {
	public render() {
		if (this.props.state.loading)
			return <Spinner label="Loading preview..." labelPosition="top" />;

		return this.document();
	}

	private document(): React.ReactNode {
		if (!this.props.state.filePreviewHref) return <></>;

		let pageHeight = this.props.state.isFullscreen
			? window.outerHeight
			: window.innerHeight - this.props.state.headerMargin;

		return (
			<div style={{ height: pageHeight, overflowY: 'hidden' }}>
				<iframe
					style={{ height: '100%', width: '100%', border: 0 }}
					title={'Document preview'}
					src={this.props.state.filePreviewHref}
				/>
			</div>
		);
	}
}

export default observer(DocumentPreviewHTML);
